export const currencyFormatter = new Intl.NumberFormat(undefined, {
    currency: "cad",
    style: "currency",
    minimumFractionDigits: 2,
})